var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whit-bg",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{directives:[{name:"active-touch",rawName:"v-active-touch"}],staticClass:"primary-btn payment-btn"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }